import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2, Lock } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import api, { formatApiErrorDetail } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export const LoginCard = () => {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [forgot, setForgot] = useState(false);
  const [forgotBusy, setForgotBusy] = useState(false);
  const [forgotMsg, setForgotMsg] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      await login(email, password);
      navigate("/");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally { setLoading(false); }
  };

  const sendForgot = async (e) => {
    e.preventDefault();
    setForgotBusy(true);
    try {
      const r = await api.post("/auth/forgot-password", { email });
      setForgotMsg(r.data.message);
    } catch (err) {
      setForgotMsg(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally { setForgotBusy(false); }
  };

  return (
    <div id="login" className="w-full max-w-md rounded-2xl border border-slate-800 bg-[#0F172A]/90 backdrop-blur p-6 sm:p-8 shadow-2xl shadow-black/40" data-testid="landing-login-card">
      <div className="flex items-center gap-3 mb-5">
        <div className="h-10 w-10 rounded-xl bg-[#10B981]/15 flex items-center justify-center"><Lock className="h-5 w-5 text-[#10B981]" /></div>
        <div>
          <h2 className="text-lg font-semibold text-white" style={{ fontFamily: "Plus Jakarta Sans, sans-serif" }}>Accedi al pannello</h2>
          <p className="text-xs text-slate-400">Area riservata ai clienti NOUVELLE WHATSAPP</p>
        </div>
      </div>
      {!forgot ? (
        <form onSubmit={submit} className="space-y-4" data-testid="landing-login-form">
          <div className="space-y-1.5">
            <Label htmlFor="landing-email" className="text-slate-300">Email</Label>
            <Input id="landing-email" type="email" required autoComplete="username" value={email} onChange={(e) => setEmail(e.target.value)}
                   className="bg-[#0A0E17] border-slate-700 text-white" data-testid="landing-login-email-input" />
          </div>
          <div className="space-y-1.5">
            <Label htmlFor="landing-password" className="text-slate-300">Password</Label>
            <Input id="landing-password" type="password" required autoComplete="current-password" value={password} onChange={(e) => setPassword(e.target.value)}
                   className="bg-[#0A0E17] border-slate-700 text-white" data-testid="landing-login-password-input" />
          </div>
          {error && <p className="text-sm text-red-400" data-testid="landing-login-error">{error}</p>}
          <Button type="submit" disabled={loading} className="w-full bg-[#10B981] hover:bg-[#059669] text-slate-950 font-semibold rounded-full h-11" data-testid="landing-login-submit-button">
            {loading ? <Loader2 className="h-5 w-5 animate-spin" /> : "Accedi"}
          </Button>
          <button type="button" onClick={() => { setForgot(true); setForgotMsg(""); }} data-testid="landing-forgot-password-link"
                  className="w-full text-center text-xs text-slate-400 hover:text-[#10B981] transition-colors">Password dimenticata?</button>
        </form>
      ) : (
        <form onSubmit={sendForgot} className="space-y-4" data-testid="landing-forgot-form">
          <p className="text-sm text-slate-300">Inserisci la tua email: riceverai un collegamento per reimpostare la password.</p>
          <Input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="bg-[#0A0E17] border-slate-700 text-white" data-testid="landing-forgot-email-input" />
          {forgotMsg && <p className="text-sm text-slate-300" data-testid="landing-forgot-message">{forgotMsg}</p>}
          <div className="flex gap-2">
            <Button type="submit" disabled={forgotBusy} className="flex-1 bg-[#10B981] hover:bg-[#059669] text-slate-950 font-semibold rounded-full" data-testid="landing-forgot-submit-button">
              {forgotBusy ? <Loader2 className="h-4 w-4 animate-spin" /> : "Invia collegamento"}
            </Button>
            <Button type="button" variant="outline" onClick={() => setForgot(false)} className="rounded-full border-slate-700 text-slate-200" data-testid="landing-forgot-back-button">Indietro</Button>
          </div>
        </form>
      )}
    </div>
  );
};
